






















export default {
  name: 'Accordion',
  props: ['content', 'data', 'title', 'open', 'footnotes', 'icon'],
  data() {
    return {
      accordionOpen: this.open,
    };
  },
};
